<template>
  <div class="org-key">
    <div class="details">
      <h2>{{ name }}</h2>
      <div v-if="token">
        <div class="input-group">
          <input
            type="text"
            :value="token"
            readonly=""
            ref="token"
          >
          <div class="input-group-button">
            <button
              aria-label="Copy to clipboard"
              class="tooltipped"
              type="button"
              v-clipboard:copy="token"
              @click="copiedToClipboard"
            >
              <svg
                aria-hidden="true"
                class="octicon octicon-clippy"
                height="16"
                version="1.1"
                viewBox="0 0 14 16"
                width="14"
              >
                <path
                  fill-rule="evenodd"
                  :d="(
                    'M2 13h4v1H2v-1zm5-6H2v1h5V7zm2 3V8l-3 3 3 3v-2h5v-2H9zM4.5 9H2v1h2.5V9zM2 ' +
                    '12h2.5v-1H2v1zm9 1h1v2c-.02.28-.11.52-.3.7-.19.18-.42.28-.7.3H1c-.55 ' +
                    '0-1-.45-1-1V4c0-.55.45-1 1-1h3c0-1.11.89-2 2-2 1.11 0 2 .89 2 2h3c.55 0 ' +
                    '1 .45 1 1v5h-1V6H1v9h10v-2zM2 5h8c0-.55-.45-1-1-1H8c-.55 ' +
                    '0-1-.45-1-1s-.45-1-1-1-1 .45-1 1-.45 1-1 1H3c-.55 0-1 .45-1 1z')"
                />
              </svg>
              <span class="tooltip-text">{{ tooltipText }}</span>
            </button>
          </div>
        </div>
      </div>
      <UiButton @click="newToken({ id })">{{ newTokenText }}</UiButton>
    </div>
    <ApiDocs v-if="token" :token="token" :orgId="id" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { UiButton } from 'keen-ui';
import ApiDocs from './ApiDocs';

export default {
  name: 'OrgKey',
  props: {
    id: {
      type: Number,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    updated: String,
    token: String,
    loading: Boolean,
    error: String,
  },
  components: {
    UiButton,
    ApiDocs,
  },
  data() {
    return {
      tooltipText: 'Copy to clipboard',
      textTimer: null,
    };
  },
  computed: {
    newTokenText() {
      return this.token ? 'Revoke and Replace' : 'Create Token';
    },
  },
  methods: {
    ...mapActions({
      newToken: 'Orgs/newToken',
    }),
    copiedToClipboard() {
      // highlight the input
      setTimeout(() => {
        this.$refs.token.focus();
        this.$refs.token.select();
      }, 0);

      // change the tooltip
      clearTimeout(this.timer);
      this.tooltipText = 'Copied!';
      this.timer = setTimeout(() => {
        this.tooltipText = 'Copy to clipboard';
      }, 1500);
    },
  },
  mounted() {
    if (this.token) {
      this.$refs.token.scrollLeft = this.$refs.token.scrollWidth;
    }
  },
};
</script>

<style lang="scss">
.org-key {
  // display: flex;
  // flex-direction: column;
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
  transition: 0.3s;
  margin-bottom: 30px;
  &:hover {
    box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
  }
  .details {
    width: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    flex-wrap: wrap;
    padding: 2px 16px;
    > * {
      display: inline-block;
      margin: 10px 20px;
      width: 200px;
    }
  }
  h2 {
    display: inline;
  }
  input {
    max-width: 200px;
    font-size: 100%;
    height: 100%;
  }
  .input-group {
    display: table;
    padding: 6px 8px;
    input {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      display: table-cell;
          border: 1px solid #d1d5da;
        border-radius: 3px;
        box-shadow: inset 0 1px 2px rgba(27,31,35,0.075);
        margin: 0;
    }
    .input-group-button {
      width: 1%;
      vertical-align: middle;
      display: table-cell;
      button {
        border-radius: 0.25em;
        border: 1px solid rgba(27,31,35,0.2);
        background-size: 110% 110%;
        margin-left: -1px;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        -webkit-appearance: button;
        background-position-x: -1px;
        background-repeat: repeat-x;
        cursor: pointer;
        user-select: none;
        background-position-y: -1px;
        background-color: #eff3f6;
        background-image: linear-gradient(-180deg, #fafbfc 0%, #eff3f6 90%);
      }
    }
  }
  .tooltipped {
    position: relative;
    display: inline-block;
    .tooltip-text {
      visibility: hidden;
      width: 150px;
      background-color: black;
      color: #fff;
      text-align: center;
      border-radius: 6px;
      padding: 10px 3px;
      position: absolute;
      z-index: 1;
      top: 150%;
      left: 50%;
      margin-left: -75px;
      font-size: 11pt;
      &:after {
        content: " ";
        position: absolute;
        bottom: 100%;
        left: 50%;
        margin-left: -5px;
        border-width: 5px;
        border-style:solid;
        border-color: transparent transparent black transparent;
      }
    }
    &:hover .tooltip-text {
      visibility: visible;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/OrgKey.vue